import { Meta } from "@/shared/components";
import { BillingContracts } from "@/admin/features/billing";

export function BillingContractsPage() {
  return (
    <>
      <Meta title="Контракты" />
      <BillingContracts />
    </>
  );
}
